import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TuneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tune"}/>
}
